var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer-events-none bg-green-300 absolute inset-0 flex items-center justify-center"},[_c('span',{staticClass:"text-white font-bold"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }